module.exports = __webpack_public_path__ + "static/media/adzuna_logo_stacked.f08d852e.svg";